import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";

export class WebsiteModuleBolaoFloatingButtonDisplayEvent extends BaseAnalyticsEvent {
  source;

  constructor(params) {
    super('display', 'floating-button', 'bolao');

    this.source = params.source;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;

    return properties;
  }
}
